import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {  MatSort } from '@angular/material/sort';
import {  MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AdminService } from '../../admin/admin.service';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { ManageCvsMappingService } from '../manage-cvs-mapping/manage-cvs-mapping.service';
import { Router } from '@angular/router';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manage-cvs-mapping',
  templateUrl: './manage-cvs-mapping.component.html',
  styleUrls: ['./manage-cvs-mapping.component.scss']
})
export class ManageCvsMappingComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  public pageTitle = 'Manage CVS Mapping';
  public alerts: any[] = [];
  public selectedApplication: string = this.adminService.selectedApplication;
  public displayedColumns: string[] = [];
  public mappingDataSource = new MatTableDataSource([]);
  public isPermissionExists = false ;

  constructor(
    private router: Router, private fb: FormBuilder, private dialog: MatDialog, private adminService: AdminService,
    private mappingService: ManageCvsMappingService,
    public commonService: TCCPCommonService, private authService: MsalService,
    public storageService: TCCPLocalStorageService) { }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  applyFilter(filterValue: string) {
    this.mappingDataSource.filter = filterValue.trim().toLowerCase();
  }

  addCVSMapping() {
    this.mappingService.pageMode = 'add';
    this.router.navigateByUrl('/admin/add-cvs-mapping');
  }

  getAllCapabilityList(fromSupportTopicChange?: boolean) {
    const selectedApp = this.selectedApplication.charAt(0).toUpperCase() + this.selectedApplication.slice(1);
    this.mappingService.getCapabilityList(selectedApp).subscribe((response: any) => {
      this.mappingDataSource.data = [];
      response.map(x => {
        const formattedJSON = {};
        const formattedArray = [];
        formattedJSON['capability'] = x.capability;
        formattedJSON['createdAt'] = x.createdAt;
        formattedJSON['internal'] = [];
        formattedJSON['external'] = [];
        x.supportTopic.map(feature => {
          if (feature.type === 'internal') {
            formattedJSON['internal'].push(feature.name);
          } else {
            formattedJSON['external'].push(feature.name);
          }
        });
        formattedArray.push(formattedJSON);
        this.mappingDataSource.data.push(formattedJSON);
      });
      setTimeout(() => {
        this.mappingDataSource.sort = this.sort;
        this.mappingDataSource.paginator = this.paginator;

        /* Adding sort by createdAt */

        let sortedContents = [];
        sortedContents = this.mappingDataSource.data.sort((obj1, obj2) =>
          obj1.createdAt < obj2.createdAt ? 1 : -1);
        this.mappingDataSource.data = sortedContents;
      });

      this.mappingDataSource.filterPredicate = (data: any, filter) => {
        const dataStr = JSON.stringify(data).toLowerCase();
        return dataStr.indexOf(filter) !== -1;
      };
    });
  }

  ngOnInit() {
    this.getAllCapabilityList();
    const roles = this.storageService.getRoles();
    this.displayedColumns = ['capability','external', 'internal'];
    this.isPermissionExists = roles?.includes('CTContentPublisherUser');
    if (this.isPermissionExists) {
      this.displayedColumns.push('action');
    }
  }

  onEdit(row) {
    this.mappingService.selectedCapability = row.capability;
    this.mappingService.pageMode = 'edit';
    this.router.navigateByUrl('/admin/add-cvs-mapping');
  }

  onDelete(row) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the mapping?'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const selectedApp = this.selectedApplication.charAt(0).toUpperCase() + this.selectedApplication.slice(1);
        this.mappingService.deleteCVSCapability(row.capability, selectedApp).subscribe(response => {
          if (response) {
            this.showAlertMessages('success', 'CVS Mapping Deleted Successfully');
            this.getAllCapabilityList();
          }
        });
      }
    });
  }
}
